import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../../../accelerator-area.service';
import { AccMentor } from '../acc-mentors-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialogService: DialogService, areaService: AcceleratorAreaService): GridSetup<AccMentor> {

	return {
		rowName: { singular: 'Mentor', plural: 'Mentors' },
		getRowKey: row => '' + row.accMentorId,
		stateKey: 'accelerator-mentors-grid',
		actions: getActions(dialogService, areaService),
		buttons: [],
		columns: getColumns(util),
	}
}
